<template>
  <Modal v-if="showModalResendSMS" @close="$emit('closeModal')">
    <Loading v-if="loading" />
    <div class="resendSMS">
      <div class="resendSMS__header">
        <span class="title">{{ $t('resendSMS') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt="CloseModal"
          @click="$emit('closeModal')"
        />
      </div>
      <div class="resendSMS__body">
        <p class="text">
          {{ $t('wantResendSMS') }}
        </p>
      </div>
      <div class="resendSMS__buttons">
        <Button
          class="resendSMS__button"
          variant="filled"
          :title="$t('resendSMS')"
          @click="resendSMSRequest"
        />
        <Button
          variant="redBordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import Loading from '@/views/Loading.vue';
import { mapActions } from 'vuex';

@Options({
  name: 'ResendSMS',
  props: ['showModalResendSMS', 'activeBoxId', 'deliveryId'],
  components: {
    Loading
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapActions('pharmacy', [
      'resendSMS',
      'getPharmacy',
      'getPickupBoxesByPharmacy'
    ]),
    async resendSMSRequest() {
      this.loading = true;
      const { id } = this.$route.params;

      if (!this.activeBoxId) {
        const payload = {
          pharmacyId: id,
          deliveryId: this.deliveryId
        };

        await this.resendSMS(payload);
        await this.$emit('loadPickupBoxes');
      } else {
        const payload = {
          pickupboxId: this.activeBoxId,
          deliveryId: this.deliveryId
        };

        await this.resendSMS(payload);
        await this.getPickupBoxesByPharmacy(id);
      }

      this.loading = false;
      this.$emit('closeModal');
    }
  }
})
export default class ResendSMS extends Vue {}
</script>

<style lang="scss" scoped>
.resendSMS {
  width: 390px;
  height: 100%;
  padding: 24px;
  .resendSMS__header {
    display: flex;
    justify-content: space-between;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .resendSMS__body {
    padding: 24px 0;
    .text {
      color: $label;
      font-size: $fourteenSize;
      line-height: $twentyTwoSize;
      font-weight: 500;
    }
  }
  .resendSMS__buttons {
    .resendSMS__button {
      width: 170px;
      margin-right: 12px;
    }
  }
}
</style>
